import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/debounceTime';
import {
  IComplaintDashboardFilterOptions,
  ComplaintsDashboardFilterKey,
  IComplaintsDashboardFilters,
} from '../../../../../core/interfaces/complaints-dashboard.interface';
import { ToastrAlertHelper } from '../../../../../core/helpers/toastr-alert-helper-service';
import {
  COMPLAINT_RANGE_OPTIONS,
  INVALID_DATE_MESSAGE,
  isPartialDate,
  validateCustomRange,
} from '../../complaints-dashboard.helper';
import { ComplaintsDashboardStore } from '../../complaints-dashboard.store';

const DATE_CHANGE_DEBOUNCE_MS = 600;

interface IDateChange {
  key: 'from' | 'to';
  input: HTMLInputElement;
}

@Component({
  selector: 'app-dashboard-filters',
  templateUrl: './dashboard-filters.component.html',
  styleUrls: ['./dashboard-filters.component.scss'],
})
export class DashboardFiltersComponent implements OnInit, OnDestroy {
  readonly rangeOpts = COMPLAINT_RANGE_OPTIONS;
  private dateChange$ = new Subject<IDateChange>();
  private subscriptions: Subscription[] = [];

  constructor(
    private store: ComplaintsDashboardStore,
    private toastrAlertHelper: ToastrAlertHelper,
  ) {}

  ngOnInit() {
    this.watchDateChanges();
  }

  setFilter(key: ComplaintsDashboardFilterKey, value: string) {
    this.store.setFilter(key, value);
  }

  clearFilters() {
    this.store.clearFilters();
  }

  onDateChange(key: 'from' | 'to', input: HTMLInputElement) {
    if (isPartialDate(input.value)) {
      return;
    }
    this.dateChange$.next({ key, input });
  }

  onDateBlur(key: 'from' | 'to', input: HTMLInputElement) {
    if (isPartialDate(input.value)) {
      this.toastrAlertHelper.warning(INVALID_DATE_MESSAGE);
      input.value = this.filters[key];
    }
  }

  private watchDateChanges() {
    this.subscriptions.push(
      this.dateChange$
        .debounceTime(DATE_CHANGE_DEBOUNCE_MS)
        .subscribe({ next: (change) => this.applyDate(change) }),
    );
  }

  private applyDate({ key, input }: IDateChange) {
    const value = input.value;
    if (isPartialDate(value) || value === this.filters[key]) {
      return;
    }
    const range = Object.assign({}, this.filters, { [key]: value });
    const error = validateCustomRange(range.from, range.to, this.maxDate);
    if (error) {
      this.toastrAlertHelper.warning(error);
      input.value = this.filters[key];
      return;
    }
    this.setFilter(key, value);
  }

  get filters(): IComplaintsDashboardFilters {
    return this.store.filters;
  }

  get filterOptions(): IComplaintDashboardFilterOptions {
    return this.store.filterOptions;
  }

  get maxDate(): string {
    return this.store.maxDate;
  }

  get rangeLabel(): string {
    const view = this.store.view;
    return view ? view.rangeLabel : '';
  }

  get isCustomRange(): boolean {
    return this.filters.range === 'custom';
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-dashboard/components/dashboard-filters/dashboard-filters.component.ts